const Colors = {
    primary: '#046615', 
    secondary: '#05b100', 
    green: '#b4dd0f', 
    textPrimary: '#212121', 
    
}
export default Colors;